module.exports = __webpack_public_path__ + "img/ch-wash.f440626a.jpg";